import Spinner from 'react-bootstrap/Spinner';

function Spinners() {
  return <Spinner animation="grow" />;
}

export default Spinners;